/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiffEntry
 */
export interface DiffEntry {
    /**
     * 
     * @type {any}
     * @memberof DiffEntry
     */
    old?: any | null;
    /**
     * 
     * @type {any}
     * @memberof DiffEntry
     */
    _new?: any | null;
}

/**
 * Check if a given object implements the DiffEntry interface.
 */
export function instanceOfDiffEntry(value: object): value is DiffEntry {
    return true;
}

export function DiffEntryFromJSON(json: any): DiffEntry {
    return DiffEntryFromJSONTyped(json, false);
}

export function DiffEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiffEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'old': json['old'] == null ? undefined : json['old'],
        '_new': json['new'] == null ? undefined : json['new'],
    };
}

export function DiffEntryToJSON(json: any): DiffEntry {
    return DiffEntryToJSONTyped(json, false);
}

export function DiffEntryToJSONTyped(value?: DiffEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'old': value['old'],
        'new': value['_new'],
    };
}

